import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import {
  AccountMetricInsightsMetricType,
  MetricValueType,
} from '../../../../interface/dtos';

export interface ChallengeFocusScoreEntityProps {
  value: number;
  userCount?: number;
  count?: number;
  uniqueUsers?: number;
  userId?: string;
  type?: MetricValueType;
  date?: string;
}

export class ChallengeFocusScoreEntity extends Entity<ChallengeFocusScoreEntityProps> {
  protected _id: string;
  static create(
    props: ChallengeFocusScoreEntityProps,
    entityId?: string
  ): ChallengeFocusScoreEntity {
    const id = entityId || v4();
    const entity = new ChallengeFocusScoreEntity({
      id,
      props,
    });
    return entity;
  }
  public validate() {}
  get metricType() {
    return AccountMetricInsightsMetricType.FocusV1;
  }
  get count() {
    return this.props.count;
  }
  get value() {
    return this.props.value;
  }
  get date() {
    const d = new Date(this.props.date);
    return isNaN(d.getTime()) ? null : d;
  }
  get userId() {
    return this.props.userId;
  }
  get avg() {
    return this.count > 0 ? this.value / this.count : this.value;
  }
  get uniqueUsers(): number {
    return this.props.uniqueUsers || 0;
  }
  get userCount() {
    return this.props.userCount || 0;
  }

  get type() {
    return this.props.type;
  }
}
